<template>
    <div>
        <div class="mt-4">
            <strong>
            Con el propósito de recopilar datos estadísticos sobre condiciones en el Programa de Educación Especial, ¿Se identificaron condiciones adicionales durante el proceso determinación elegibilidad? 
            </strong>
        </div>
        <div class="mt-4">
            <ValidationProvider
            v-slot="{ errors }"
            rules="required"
            name="ConditionsInProcessNecessary"
            >
            <div class="custom-radio">
                <CustomRadio
                v-model="value.isConditionsInProcessNecessary"
                :error="errors[0]"
                custom-error-msg="Favor de contestar si se identificaron condiciones en el proceso."
                name="isConditionsInProcessNecessary"
                :options="radioConditionsInProcessNecessary.options"
                is-inline
                :is-disabled="disabled"
                @input="radioConditionsInProcessNecessaryChange($event)"
                />
            </div>
            </ValidationProvider>
        </div>        

        <div
        v-if="value.isConditionsInProcessNecessary"          
        class="row ml-0 pl-1"
        >
            <div class="col-12 pl-0">               
                <div class="row mt-3">
                    <div v-if="!disabled" class="col-4 border-right mt-3">
                        <ValidationProvider
                            v-slot="{ errors }"
                            :rules="dropDownConditionCatalog.required ? 'required' : ''"
                            name="ConditionsInProcessNecessary"
                        >
                        <CustomDropDown
                            id="conditionsCatalog"
                            v-model="value.eligibilityDeterminationConditions.condition"
                            class="w-50 d-inline"     
                            label="Catálogo de condiciones:"         
                            custom-error-msg="Favor seleccionar al menos uno para continuar"
                            :error="errors[0]"               
                            placeholder="Seleccione"
                            fieldkey="id"
                            fieldname="name"
                            :options="conditions"
                            :disabled="disabled"              
                        />
                        </ValidationProvider>
                        <div v-if="!disabled" class="mt-4 d-flex justify-content-end">
                        <ActionButton
                            id="btnAddEligibilityDeterminationConditionClick"
                            i="fas fa-file-plus"
                            variant="success mt-1 pl-5 pr-5"
                            type="button"
                            :disabled="disabled"
                            @click="addEligibilityDeterminationConditionHandler"
                        >
                            Añadir
                        </ActionButton>
                        </div>
                    </div>
                    <div class="col-4" v-if="value.eligibilityDeterminationConditions.selectedItems.length > 0">
                        <CustomChipsGroup
                            title="Condicion(es) Seleccionada(s):"
                            no-background
                            object-text="name"
                            object-title="title"
                            object-sub-title="subTitle"
                            :selected-items="this.value.eligibilityDeterminationConditions.selectedItems"
                            :disabled="disabled"
                            @itemMarkedForDeletion="removeAddEligibilityDeterminationConditionItemSelected" 
                        />
                    </div>         
                </div>  
            </div>  
        </div>  
    </div>  
</template>

<script>
import { CustomRadio, ActionButton, CustomDropDown, CustomChipsGroup } from '@/components/common';
import alert from '@/mixin/alert.mixin';
import _ from 'lodash';
export default {
  name: 'EligibilityDeterminationConditions',
  mixins: [alert], 
  props: {
    value: {
      type: Object,
      required: true,
      default: () => {
         return {            
            isConditionsInProcessNecessary: false,
            eligibilityDeterminationConditions: {
                condition: null,
                selectedItems: [],
            },           
         }
      }
    },
    conditions: {
        type: Array,
        required: true,
        default:()=> {
            return [];
        }
    },
    disabled: {
        type: Boolean,
        required: true,
        default:()=> false                    
    }
  },  
  data() {
    return {
       radioConditionsInProcessNecessary: {
          options: [
            { label: 'Si', value: true },
            { label: 'No', value: false },
          ],
        },
        dropDownConditionCatalog:{            
          required: true          
        }           
    };
  },
  components: {
    CustomRadio,
    ActionButton,
    CustomDropDown,
    CustomChipsGroup
  },
  methods: {
     addEligibilityDeterminationConditionHandler(){
      if (!this.value.eligibilityDeterminationConditions.condition) {
        this.ShowToast('Error', 'Debe seleccionar una opción', 'error');        
        return false;
      }      

      let item = {};
      item.id = this.value.eligibilityDeterminationConditions.condition.id;
      item.association = null;
      item.code = this.value.eligibilityDeterminationConditions.condition.code;
      item.title = this.value.eligibilityDeterminationConditions.condition.name;
        
      this.removeEligibilityDeterminationCondition(item);    
    },
    removeEligibilityDeterminationCondition(item) {
      this.value.eligibilityDeterminationConditions.selectedItems.push(item);
      this.dropDownConditionCatalog.required = false;       
      this.value.eligibilityDeterminationConditions.condition = null;
      this.conditions = this.conditions.filter(
        (x) => x.id !== item.id
      );     
    },
    removeAddEligibilityDeterminationConditionItemSelected(item) {
      if (item.title) {
        item.name = item.title;
      }

      this.conditions.push(item);

      this.conditions = _.orderBy(this.conditions, 'code', 'asc');

      this.value.eligibilityDeterminationConditions.condition = null;
      this.value.eligibilityDeterminationConditions.selectedItems = this.value.eligibilityDeterminationConditions.selectedItems.filter(
        (x) => x.id !== item.id
      );

      this.dropDownConditionCatalog.required = true; 
      if(this.value.eligibilityDeterminationConditions.selectedItems.length)
      {
        this.dropDownConditionCatalog.required = false; 
      }
    },
    radioConditionsInProcessNecessaryChange(getIsConditionsInProcessNecessary) {
      //get to avoid broke anothers implements

      if (getIsConditionsInProcessNecessary == null) {
        this.value.isConditionsInProcessNecessary = null;        
      } else {
        this.value.isConditionsInProcessNecessary = getIsConditionsInProcessNecessary;        
      }
    },
  }
};
</script>

<style scoped lang="scss">
 .custom-ddl{
   ::v-deep {
    .input-label{
      color: #212529 !important;
    }
  }
}

.custom-radio{
    ::v-deep{
        div.col-12{
            padding-left: 0;
        }
    }
}
</style>
